import { render, staticRenderFns } from "./AppNavigation.vue?vue&type=template&id=0a8a089b&scoped=true&"
import script from "./AppNavigation.vue?vue&type=script&lang=js&"
export * from "./AppNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigation.vue?vue&type=style&index=0&id=0a8a089b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a089b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
